import { IOverviewHeroProps } from "./OverviewHero.types";
import { OverviewDisplayPro } from "./components/OverviewDisplayPro";
import * as S from "./OverviewHero.styles";
import React, { Fragment } from "react";
import { StyledContainer } from "components/StyledContainer";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";
import { InView } from "react-intersection-observer";

export const OverviewHero = ({
  title,
  slides,
}: Readonly<IOverviewHeroProps>) => {
  return (
    <Fragment>
      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 72, bottom: 0 }}
      >
        <S.TitleContainer>
          <MicrositeHeading
            title={title}
            isCentered
            isMainTitle
            titleWeight={900}
            spacing={{ top: 0, bottom: 16 }}
          />
        </S.TitleContainer>
      </StyledContainer>

      <InView
        as="div"
        threshold={0.3}
        trackVisibility
        delay={100}
        initialInView
      >
        {({ inView, ref }) => (
          <div ref={ref}>
            <OverviewDisplayPro slides={slides} isInView={inView} />
          </div>
        )}
      </InView>
    </Fragment>
  );
};
